import React from 'react';
import UHCTooltipSlider from '../../../../Dumb/Atoms/TooltipSlider/TooltipSlider';
import { BoxPip, BulletBox, ExtremePip, Pip, TextPip, DivTooltip, BoxTooltip } from './BoxPipesAndValues.styled';
import { UHC_SliderProps } from '../Slider';
import { SliderColorsOptions, getSliderColor } from '../sliderColors';

export interface BoxPipesAndValuesProps {
    pipes: UHC_SliderProps['pipes'],
    pipeSelected: UHC_SliderProps['pipeState']['pipeSelected'],
    pipesDisabled?:UHC_SliderProps['pipesDisabled'],
    sizePipe: number
    color: SliderColorsOptions
}

const verifyIsDisebled = (value: number, disabled: BoxPipesAndValuesProps['pipesDisabled']) => {
    return (disabled) ? value > disabled.max || value < disabled.min : false;
}

const UHC_BoxPipesAndValues: React.FC<BoxPipesAndValuesProps> = (props: BoxPipesAndValuesProps) => {
    const { pipes, pipeSelected: currentPipe, sizePipe, pipesDisabled: disabled } = props;
    return (
        <>
            <BulletBox data-testid={`BulletBox`}>
                {pipes.map((val, i) => {

                    const isDisabled = verifyIsDisebled(i, disabled);

                    return (
                        <BoxPip data-testid={`UHCBoxPipesAndValues${i}`} key={i} >
                            {(i !== 0 && i !== pipes.length - 1) ?
                                <Pip width={sizePipe} />
                                :
                                <ExtremePip />
                            }
                            {
                                isDisabled ?
                                    <BoxTooltip
                                        placement="top"
                                        title={
                                            <UHCTooltipSlider>
                                                {val.tooltip}
                                            </UHCTooltipSlider>
                                        }
                                    >
                                        <DivTooltip />
                                    </BoxTooltip>
                                    : null
                            }

                            <TextPip color={getSliderColor(props.color)} data-testid={`TextPip${i}`} isSelect={currentPipe == i} isDisabled={isDisabled}>
                                {val.value}
                            </TextPip>
                        </BoxPip>
                    )
                })}
            </BulletBox>
        </>
    );
}

export default UHC_BoxPipesAndValues;